(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.headerType = this.getAttribute('data-header-type'); // 'transparent' or 'solid'
      this.isHomepage = document.body.classList.contains('template-index');
      this.sectionHeader = document.querySelector('.section-header');
      this.scrollThreshold = 80; 
      this.ticking = false;
    }

    connectedCallback() {
      if (!this.sectionHeader) return;

      // Add scroll listener
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      
      // Run once on load to set initial state
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.checkScroll();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    checkScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Logic for Transparent Homepage Header
      if (this.headerType === 'transparent' && this.isHomepage) {
        if (scrollTop > this.scrollThreshold) {
          if (!this.sectionHeader.classList.contains('is-scrolled')) {
            this.sectionHeader.classList.add('is-scrolled');
          }
        } else {
          if (this.sectionHeader.classList.contains('is-scrolled')) {
            this.sectionHeader.classList.remove('is-scrolled');
          }
        }
      }

      // Logic for Solid Header (Shadow management)
      if (this.headerType === 'solid') {
        if (scrollTop > 10) {
          if (!this.sectionHeader.classList.contains('is-scrolled')) {
            this.sectionHeader.classList.add('is-scrolled');
          }
        } else {
          if (this.sectionHeader.classList.contains('is-scrolled')) {
            this.sectionHeader.classList.remove('is-scrolled');
          }
        }
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
